// Parámetros de acceso que pueden venir en la URL:
//  - ?t=<token>: token de acceso de un magic link / link compartido.
//  - ?cid=&lastname=(&c=): links viejos (mails anteriores a la migración). Ya
//    no inician sesión solos: sólo precargan el formulario de login. `c`
//    (empresa) se descarta: la empresa sale siempre del POS.
export const AUTH_QUERY_KEYS = ["t", "cid", "lastname", "c"];

const digits = value => String(value || "").replace(/[^0-9]/g, "");

const safeDecode = value => {
  try {
    return decodeURIComponent(value);
  } catch (e) {
    return value;
  }
};

// El token de los links nuevos viaja en el FRAGMENTO (#t=...): no llega a los
// logs del servidor ni al Referer. Se lee primero de ahí; ?t= se acepta por
// compatibilidad.
export const readAuthQuery = (search, hash) => {
  const params = new URLSearchParams(search || "");
  const hashParams = new URLSearchParams(String(hash || "").replace(/^#/, ""));
  const accessToken = (hashParams.get("t") || params.get("t") || "").trim();
  const cid = digits(params.get("cid"));
  const lastname = safeDecode(params.get("lastname") || "").trim();
  return {
    accessToken: accessToken || null,
    legacy: cid && lastname ? { cid, lastname } : null,
    hasAuthParams:
      AUTH_QUERY_KEYS.some(key => params.has(key)) || hashParams.has("t")
  };
};

// Saca de la URL los parámetros consumidos (query y fragmento), sin recargar
// ni tocar el router.
export const stripAuthQuery = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    const hashParams = new URLSearchParams(
      window.location.hash.replace(/^#/, "")
    );
    const inQuery = AUTH_QUERY_KEYS.some(key => params.has(key));
    if (!inQuery && !hashParams.has("t")) return;
    AUTH_QUERY_KEYS.forEach(key => params.delete(key));
    hashParams.delete("t");
    const qs = params.toString();
    const hs = hashParams.toString();
    window.history.replaceState(
      window.history.state,
      "",
      window.location.pathname + (qs ? "?" + qs : "") + (hs ? "#" + hs : "")
    );
  } catch (e) {
    // sin history API: nada que limpiar
  }
};

// Ruta con el CID reemplazado (/checkin/{cid} o /cancel/{cid}); null si la ruta
// no tiene CID.
export const replaceCidInPath = (pathname, cid) => {
  const re = /(\/(?:checkin|cancel)\/)(\d+)/;
  return re.test(pathname || "") ? pathname.replace(re, `$1${cid}`) : null;
};
export const pathCid = pathname => {
  const match = /\/(?:checkin|cancel)\/(\d+)/.exec(pathname || "");
  return match ? match[1] : null;
};
